import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Banner from "./components/Banner";
import Tabs from "./components/Tabs";
import Especialidades from "./components/Especialidades";
import Destacadas from "./components/Destacadas";
import ProfesionalesList from "./components/ProfesionalList";
import TestimoniosList from "./components/Testimonios";
import Cifras from "./components/Cifras";
import Mapa from "./components/Mapa";
import Footer from "./components/Footer";

import PorDisponibilidad from "./pages/PorDisponibilidad";
import PorEcografias from "./pages/PorEcografias";
import ReservaPage from "./pages/agendar";
import PorProfesional from "./pages/PorProfesional";
import Presupuesta from "./pages/Presupuesta";
import EspecialidadesTodas from "./pages/Especialidades";
import DetalleEspecialidad from "./pages/DetalleEspecialidad";
import Profesionales from "./pages/Profesionales";
import DetalleProfesional from "./pages/DetalleProfesional";
import ArancelesEcografias from "./pages/ArancelesEco";
import Devoluciones from "./pages/Devoluciones";
import './styles/global.css';

function App() {
  return (
    <BrowserRouter>
      <div>
        <Nav />
        <Routes>
          {/* Página principal */}
          <Route path="/" element={
  <>
    <div className="section-divider">
      <Banner />
    </div>

    <div className="section-divider">
      <Especialidades />
    </div>
    <div className="section-divider">
      <ProfesionalesList />
    </div>
    <div className="section-divider">
      <TestimoniosList />
    </div>
    <div className="section-divider">
      <Cifras />
    </div>
    <div className="section-divider">
      <Mapa />
    </div>
  </>
} />


          {/* Página de reserva */}
          <Route path="/reserva" element={<ReservaPage />} />
          <Route path="/agenda-tu-hora/" element={<ReservaPage />} />
          <Route path="/reserva/profesional" element={<PorProfesional />} />
          <Route path="/reserva/ecografia" element={<PorEcografias />} />
          <Route path="/reserva/disponibilidad" element={<PorDisponibilidad />} />

          <Route path="/presupuesto" element={<Presupuesta />} />

          <Route path="/especialidades" element={<EspecialidadesTodas />} />
          <Route path="/especialidad/:nombre" element={<DetalleEspecialidad />} />

          <Route path="/profesionales" element={<Profesionales />} />
          <Route path="/profesional/:id" element={<DetalleProfesional />} />

          <Route path="/aranceles-ecografias" element={<ArancelesEcografias />} />

          <Route path="/devoluciones" element={<Devoluciones />} />
        </Routes>

        {/* Botón flotante de WhatsApp */}
        <a
          href="https://wa.me/56956065805" // Reemplaza con tu número de WhatsApp
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
          />
        </a>

        {/* Esto se verá en todas las rutas */}
        <Tabs />

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;